export const PERSON_NAME_REGEX = /^[-a-zA-Z0-9 '.&]*$/;
export const US_SLASH_DATE_REGEX = /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/;
export const ISO_DATE_REGEX = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
export const NUMERIC = /(^[0-9]*$)/;
export const BOOLEAN = /(^(true|false)$)/;
export const LEGAL_DOC_ID_REGEX = /^[A-Za-z0-9]+(-[A-Za-z0-9]+)*$/;
